<button
  #trigger
  cdkOverlayOrigin
  #origin="cdkOverlayOrigin"
  type="button"
  class="core-ui-action-menu__trigger"
  aria-haspopup="menu"
  [class.is-open]="isOpen"
  [attr.aria-label]="triggerAriaLabel"
  [attr.aria-expanded]="isOpen"
  [disabled]="isTriggerDisabled"
  (click)="toggle()"
>
  <core-ui-icon name="more_vert" size="20" color="currentColor"></core-ui-icon>
</button>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayPositions]="positions"
  [cdkConnectedOverlayPush]="push"
  [cdkConnectedOverlayViewportMargin]="viewportMargin"
  [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
  [cdkConnectedOverlayHasBackdrop]="false"
  (overlayOutsideClick)="close(true)"
  (detach)="close()"
  (positionChange)="onPositionChange($event)"
>
  <core-ui-context-menu
    [size]="size"
    [appearance]="appearance"
    [variant]="variant"
    [openDirection]="menuPosition"
    [ariaLabel]="ariaLabel"
    [items]="items"
    (itemSelected)="selectAction($event)"
    (dismissed)="close(true)"
  ></core-ui-context-menu>
</ng-template>
